import React, { useEffect, useRef } from 'react'
import { LoadingPage } from '@wallyhealth/web-core'
import { useSearchParams } from 'react-router-dom'
import intelService from '../../services/intelService'
import ErrorPageTemplate from '../../components/ErrorPageTemplate'
import CheckInDetailsPage from './CheckInDetailsPage'
import { useAppointmentDetails } from './hooks'

const CheckInFlow = () => {
  const [searchParams] = useSearchParams()
  const encodedId = searchParams.get('id')
  const hasRecordedView = useRef(false)

  const {
    isLoading,
    isNotFound,
    shouldRetryLoading,
    data,
    reload,
    isCheckingIn,
    handleCheckIn
  } = useAppointmentDetails({ encodedId })

  useEffect(() => {
    if (data && !hasRecordedView.current) {
      hasRecordedView.current = true
      intelService.recordEvent({
        eventName: 'CheckInDetailsPage:viewed',
        properties: {
          encodedId,
          status: data.status
        }
      })
    }
  }, [data, encodedId])

  if (isLoading) {
    return <LoadingPage isLoaderFaded={true} />
  }

  if (!data) {
    if (isNotFound) {
      return (
        <ErrorPageTemplate
          title="Invalid link."
          description="Please double-check the link and try again."
        />
      )
    }

    if (shouldRetryLoading) {
      return (
        <ErrorPageTemplate
          description="Something went wrong. Please try again."
          ctaHandler={reload}
        />
      )
    }

    return null
  }

  return (
    <CheckInDetailsPage
      encodedId={encodedId}
      data={data}
      onCheckIn={handleCheckIn}
      isCheckingIn={isCheckingIn}
    />
  )
}

export default CheckInFlow
